/**
 * Spreadsheet constants
 * @fileoverview Constant values shared across files and functions
 */

import type { HandsontableColumnSettings } from './types';

const menuHeight = 60;
const notesHeight = 30;
const rowHeight = 26;

const sliderContentWidth = 360;
const sliderHeaderWidth = 60;
const sliderWidth = sliderHeaderWidth + sliderContentWidth;

const visibleRowsByHeightSet = {
  short: 18,
  medium: 24,
  tall: 36,
};

interface DefaultColumnSettingsType extends HandsontableColumnSettings {
  width: number;
  validation: {
    errorMessage: string;
  };
}

const defaultColumnSettings: Record<
  'typeahead' | 'datepicker' | 'dropdown' | 'numeric' | 'text' | 'checkbox' | 'currency' | 'percentage',
  DefaultColumnSettingsType
> = {
  typeahead: {
    type: 'autocomplete',
    strict: true,
    width: 140,
    validator: 'AutocompleteValidator',
    validation: {
      errorMessage: 'This field should be one of the provided options',
    },
  },
  datepicker: {
    type: 'date',
    width: 120,
    dateFormat: 'MM/DD/YYYY',
    strict: true,
    correctFormat: true,
    datePickerConfig: {
      showWeekNumber: true,
    },
    validator: 'DateValidator',
    validation: {
      errorMessage: 'This field should follow the format MM/DD/YYYY',
    },
  },
  dropdown: {
    type: 'dropdown',
    strict: true,
    width: 140,
    validator: 'DropdownValidator',
    validation: {
      errorMessage: 'This field should be one of the provided options',
    },
  },
  numeric: {
    type: 'numeric',
    className: 'htRight',
    numericFormat: {
      pattern: {
        optionalMantissa: true,
        thousandSeparated: true,
        mantissa: 2,
      },
    },
    width: 140,
    validator: 'NumericValidator',
    validation: {
      errorMessage: 'This field should be a number',
    },
  },
  text: {
    type: 'text',
    width: 160,
    validation: {
      errorMessage: 'Invalid value',
    },
  },
  checkbox: {
    type: 'checkbox',
    width: 120,
    validation: {
      errorMessage: 'Invalid value',
    },
  },
  currency: {
    type: 'numeric',
    numericFormat: {
      pattern: '$ 0,0.00',
    },
    width: 150,
    validator: 'NumericValidator',
    validation: {
      errorMessage: 'This field should be a number',
    },
  },
  percentage: {
    type: 'numeric',
    numericFormat: {
      pattern: {
        output: 'percent',
        optionalMantissa: true,
        mantissa: 2,
        thousandSeparated: true,
      },
    },
    width: 140,
    validator: 'NumericValidator',
    validation: {
      errorMessage: 'This field should be a number',
    },
  },
};

const ALLOWED_COLUMN_TYPES = Object.keys(defaultColumnSettings);

const ERRORS_BATCH_UPDATE_EVENT_COMPLETED = 'ErrorsBatchUpdateCompleted';
export {
  rowHeight,
  visibleRowsByHeightSet,
  menuHeight,
  notesHeight,
  sliderContentWidth,
  sliderHeaderWidth,
  sliderWidth,
  defaultColumnSettings,
  ALLOWED_COLUMN_TYPES,
  ERRORS_BATCH_UPDATE_EVENT_COMPLETED,
};
